import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Funciona con ingreso gig (variable)?',
    a: 'Sí, la plantilla incluye una columna especial que promedia tus últimos meses para darte un presupuesto realista.'
  }, {
    q: '¿Las actualizaciones son gratis?',
    a: 'Sí, tienes acceso vitalicio (lifetime) a todas las mejoras futuras para compradores de Etsy.'
  }, {
    q: '¿Qué pasa si no sé usar Excel?',
    a: 'No te preocupes. Incluye 3 mini-videos que te guían paso a paso, y las fórmulas hacen los cálculos por ti. Solo llenas las celdas amarillas.'
  }, {
    q: '¿Es imprimible?',
    a: 'Sí, incluye versiones en PDF perfectas para imprimir y pegar en la nevera o pared.'
  }, {
    q: '¿Hay devoluciones?',
    a: 'Aplicamos la política estándar de Etsy para productos digitales, pero tenemos 5 estrellas por su simplicidad y efectividad.'
  }, {
    q: '¿Sirve si tengo 1, 2 o 3 hijos?',
    a: 'Es totalmente escalable. Puedes ajustar las columnas de gastos según el tamaño de tu familia.'
  }, {
    q: '¿El plan de comidas incluye comida latina?',
    a: '¡Por supuesto! Incluye ideas con arroz, frijoles, tacos y más, calculadas para alimentar a una familia con unos $30 al día.'
  }, {
    q: '¿Funciona en Google Sheets?',
    a: 'Sí, recibes enlaces para hacer copias directas en Google Sheets y usarlo gratis online.'
  }, {
    q: '¿Sirve para deudas altas?',
    a: 'Sí, el método Snowball (bola de nieve) incluido funciona perfectamente incluso para deudas de más de $10k.'
  }];
  return <section className="py-20 px-4 bg-cream" data-id="element-24">
      <div className="max-w-3xl mx-auto" data-id="element-25">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-26">
          <h2 className="text-3xl md:text-4xl font-bold text-purple-dark mb-4" data-id="element-27">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-28">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} data-id="element-29" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-white rounded-2xl shadow-sm border border-purple/10 overflow-hidden" data-id="element-30">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" aria-expanded={isOpen} data-id="element-31">
        <span className="font-bold text-charcoal pr-4" data-id="element-32">{question}</span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3
      }} data-id="element-33">
          <ChevronDownIcon className="w-5 h-5 text-purple" data-id="element-34" />
        </motion.div>
      </button>

      <AnimatePresence data-id="element-35">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-36">
            <div className="px-6 pb-5 text-charcoal/80 border-t border-cream pt-4" data-id="element-37">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}